import React from 'react';
import Content from '../../components/Content';
import WeeklyNetTraffic from '../WeeklyNetTraffic';
import { ErrorCodes } from '../../utils/errorCodes';
import { formatFrontendSupportError } from '../../utils/frontendErrorFormat';
import classes from './WeeklyNetTrafficPage.module.css';

const FRONTEND_WEEKLY_TRAFFIC_PAGE_ERROR_CODES = {
  PAGE_RENDER_FAILED: ErrorCodes.API_INTERNAL_ERROR,
};

const buildWeeklyTrafficPageSupportError = (errorCode, pageInfo, sourceMessage) =>
  formatFrontendSupportError({
    errorCode,
    pageInfo,
    sourceMessage,
  });

class WeeklyTrafficPageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('WeeklyNetTrafficPage render error:', error, errorInfo);
  }

  render() {
    const { hasError, error } = this.state;
    if (hasError) {
      return this.props.renderFallback(error);
    }
    return this.props.children;
  }
}

const WeeklyTrafficPageSupportFallback = ({ error }) => {
  const [copiedSupportError, setCopiedSupportError] = React.useState(false);
  const rawErrorMessage =
    error?.message ||
    (typeof error === 'string' ? error : 'Weekly network traffic page render failed');
  const supportErrorMessage = buildWeeklyTrafficPageSupportError(
    FRONTEND_WEEKLY_TRAFFIC_PAGE_ERROR_CODES.PAGE_RENDER_FAILED,
    'Weekly Network Traffic Page / Render Failed',
    rawErrorMessage
  );

  const handleCopySupportError = async () => {
    try {
      await navigator.clipboard.writeText(supportErrorMessage);
      setCopiedSupportError(true);
      setTimeout(() => setCopiedSupportError(false), 2000);
    } catch (copyError) {
      setCopiedSupportError(false);
    }
  };

  return (
    <div className={classes.pageSupportFallback}>
      <strong>Support Error:</strong>
      <code className={classes.supportErrorCode}>{supportErrorMessage}</code>
      <button
        type='button'
        className={classes.copySupportErrorButton}
        onClick={handleCopySupportError}
      >
        {copiedSupportError ? 'Copied' : 'Copy Error Details'}
      </button>
    </div>
  );
};

const WeeklyNetTrafficPage = () => {
  return (
    <Content currentMenu='traffic' headerTitle='Weekly Network Traffic'>
      <WeeklyTrafficPageErrorBoundary
        renderFallback={(error) => <WeeklyTrafficPageSupportFallback error={error} />}
      >
        <div className={classes.container}>
          <WeeklyNetTraffic pageContext='Weekly Network Traffic Page' />
        </div>
      </WeeklyTrafficPageErrorBoundary>
    </Content>
  );
};

export default WeeklyNetTrafficPage; 
